// `related-category` is platform-agnostic — the same item id pair drives
// Pop Index (Overview tab), TT, and IG enrichment. Each platform tab fetches
// its own data from its pair endpoint and skips the row if no match.
// Legacy `related-hashtag` (TT) and `instagram-related-hashtag` (IG) were
// removed when the keyword-matching project dropped the per-platform related
// hashtag tables; any existing rows of those types are orphaned.
export const SUPPORTED_TYPES_BY_DATASOURCE = {
    overview: new Set(['category', 'brand', 'related-category']),
    google: new Set(['category', 'brand', 'affinity']),
    tiktok: new Set(['category', 'brand', 'hashtag', 'related-category']),
    instagram: new Set([
        'category',
        'brand',
        'instagram-hashtag',
        'related-category',
    ]),
};
